import { User } from '@sdk/users/types/User';
import { Persona } from '@sdk/personaCollection/types/Persona';
import { PersonasDict } from '@sdk/personaCollection/types/PersonasDict';

import { MentionsDict } from './useMentionPersonas.types';

export function isMentionable(persona: Persona, memberIds: number[], allUsers: User[]) {
  if (persona.type === 'user' && persona.isActive) {
    return (
      memberIds.includes(persona.id) || persona.allTypeGroupIds.some((id) => memberIds.includes(id))
    );
  }

  return allUsers.some((user) => user.isActive && user.allTypeGroupIds.includes(persona.id));
}

export function getEmptyMentionsDict(): MentionsDict {
  return {
    everyone: [],
    location: [],
    position: [],
    group: [],
    user: [],
  };
}

export function flattenMentionIdsByType(
  personasDict: PersonasDict,
  dictKeys: string[],
  mentionIdsByType: MentionsDict
) {
  return dictKeys.reduce((mentionPersonas, personaType) => {
    const personaIds = mentionIdsByType[personaType];
    personaIds.forEach((id) => {
      mentionPersonas.push(personasDict[id]);
    });
    return mentionPersonas;
  }, [] as Persona[]);
}
